import { GetTermsConditions } from "../../../connection/terms-conditions";
import { Action, AsyncAction } from "../../../types/actions";

export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS';
export function getTermsConditions(terms_id: number): AsyncAction {
	return {
		type: GET_TERMS_CONDITIONS,
		promise: GetTermsConditions(terms_id),
	};
}

export const CLEAR_TERMS_CONDITIONS = 'CLEAR_TERMS_CONDITIONS';
export function clearTermsConditions(): Action {
	return {
		type: CLEAR_TERMS_CONDITIONS,
		payload: null,
	};
}
